// import other from "./other";

// // ==============================|| MENU ITEMS ||============================== //

// const menuItems = {
//   items: [other],
// };

// export default menuItems;

import other from "./other";

import AllOther from "./allOther";
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    // other,
    AllOther,
  ],
};

export default menuItems;
